import { environment } from './environment';

const DEFAULT_ORCHESTRATOR_BASE_URL = '/api/orchestrator';

/**
 * Orchestrator HTTP prefix. Host environment files copied in at deploy may omit the key;
 * those builds still compile and call the same relative path.
 */
export function readOrchestratorBaseUrl(): string {
  const configured = (environment as { orchestratorBaseUrl?: string }).orchestratorBaseUrl?.trim();
  return configured || DEFAULT_ORCHESTRATOR_BASE_URL;
}
